<ul class="layout-menu">
    <ng-container *ngFor="let item of finalMenuItemsCollections; let i = index">
        <li  [ngStyle]="{ 'color': item.color  +' !important'}"
            app-menuitem
            *ngIf="!item.separator"
            [item]="item"
            [index]="i"
            [root]="true"
        ></li>
        <li *ngIf="item.separator" class="menu-separator"></li>
    </ng-container>
</ul>
